import React from "react";
import {H1, Logo, Text, theme} from "@reside/ui";
import {DocumentTitle} from "../../atoms/document-title";
import {AutoLogoutInfoBar} from "../../atoms/auto-logout";
import {PageAdminLoginForm} from "./PageAdminLoginForm";
import {useAutoLogoutInfo} from "../../contexts/AutoLogoutInfoContext";
import {StyledCard} from "./style";

type Props = Readonly<{
  error: any;
  isLoading: boolean;
}>;

/**
 * Login form wrapper with layout and title.
 */
export const LoginFormWrapper = ({error, isLoading}: Props) => {
  const {isAutoLoggedOut} = useAutoLogoutInfo();

  return (
    <div
      style={{
        marginTop: theme.space[5],
        paddingBottom: isAutoLoggedOut ? "100px" : "0",
      }}
    >
      <AutoLogoutInfoBar />
      <Logo />
      <DocumentTitle title="Reside - Admin - Sign In" />
      <StyledCard>
        <H1 style={{textAlign: "center"}}>Sign in</H1>
        <Text
          as="p"
          fontSize="18px"
          style={{textAlign: "center", marginBottom: "32px"}}
          lineHeight={["24px"]}
        >
          Enter your email address and password to continue
        </Text>
        <PageAdminLoginForm error={error} isLoading={isLoading} />
      </StyledCard>
    </div>
  );
};
